import Icon from '../Icon';

const Offline = (props) => (
  <Icon
    {...props}
    viewBox="0 0 7 6"
    color="#FFAD3B"
    path="M3.60218 3.00144C4.31259 2.27199 4.48816 1.17485 4.04086 0.260124C4.01288 0.193531 4.02564 0.116782 4.07367 0.0628281C4.12169 0.00887409 4.19645 -0.0126866 4.26583 0.00740273C4.80011 0.145123 5.28778 0.423345 5.67824 0.813187C6.88673 1.99054 6.91224 3.92462 5.73523 5.13345C4.52655 6.31061 2.59256 6.28526 1.41514 5.07683C1.02509 4.68662 0.746729 4.19901 0.609017 3.66474C0.588826 3.59526 0.610416 3.52036 0.664491 3.4723C0.718566 3.42423 0.795474 3.41157 0.862103 3.43976C1.77639 3.88688 2.87298 3.71146 3.60218 3.00144Z"
  />
);

export default Offline;
